import React, { createContext, useContext } from 'react';

interface BackendFeatureFlags {
	isTeam25AppRebrandEnabled: boolean;
}

const BackendFeatureFlagsContext = createContext<BackendFeatureFlags>({
	isTeam25AppRebrandEnabled: false,
});

export const useBackendFeatureFlag = (): BackendFeatureFlags => {
	return useContext(BackendFeatureFlagsContext);
};

interface BackendFeatureFlagsProviderProps {
	children: React.ReactNode;
	featureFlags: BackendFeatureFlags;
}

/**
 * Provider for feature flags provided by the backend service `app-switcher-bff`
 */
export const BackendFeatureFlagsProvider: React.FC<BackendFeatureFlagsProviderProps> = ({
	children,
	featureFlags,
}) => {
	return (
		<BackendFeatureFlagsContext.Provider value={featureFlags}>
			{children}
		</BackendFeatureFlagsContext.Provider>
	);
};
